const ICONS = {
  water_bottle: (
    <g><rect x="34" y="14" width="12" height="9" rx="2" fill="#0A2540" /><rect x="27" y="22" width="26" height="46" rx="10" fill="#17A2A2" />
      <rect x="31" y="34" width="6" height="24" rx="3" fill="#fff" opacity=".6" /><path d="M27 44h26" stroke="#E0B33A" strokeWidth="4" /></g>
  ),
  fruit: (
    <g><ellipse cx="40" cy="46" rx="20" ry="23" fill="#E0B33A" /><ellipse cx="34" cy="40" rx="6" ry="9" fill="#FCD34D" opacity=".8" />
      <path d="M40 23 q10 -12 20 -4 q-10 8 -20 4z" fill="#2BA36B" /></g>
  ),
  basket: (
    <g><path d="M16 36 h48 l-7 30 h-34 z" fill="#C08A4A" /><path d="M20 46h40M22 56h36M30 36v30M40 36v30M50 36v30" stroke="#8A5E2C" strokeWidth="2.5" />
      <path d="M24 36 q16 -26 32 0" stroke="#8A5E2C" strokeWidth="4" fill="none" /><rect x="16" y="33" width="48" height="6" rx="3" fill="#17A2A2" /></g>
  ),
  stall: (
    <g><circle cx="40" cy="40" r="28" fill="#fff" fillOpacity=".55" stroke="#17A2A2" strokeWidth="4" strokeDasharray="7 6" />
      <path d="M26 46h28" stroke="#0A2540" strokeWidth="4" strokeLinecap="round" /></g>
  ),
  villager: (
    <g><path d="M30 64 V36 a4 4 0 0 1 8 0 V30 a4 4 0 0 1 8 0 V34 a4 4 0 0 1 8 0 V44 l5 -6 a4 4 0 0 1 6 5 l-12 18 q-4 6 -12 6 h-5 q-6 0 -6 -3z" fill="#6B4630" />
      <path d="M20 26 q-6 -8 0 -16M62 22 q8 -6 6 -16" stroke="#E0B33A" strokeWidth="3.5" strokeLinecap="round" fill="none" /></g>
  ),
  branch: (
    <g><path d="M10 50 Q40 40 70 22" stroke="#6B4F3A" strokeWidth="7" strokeLinecap="round" fill="none" />
      <ellipse cx="30" cy="36" rx="10" ry="6" fill="#2BA36B" transform="rotate(-30 30 36)" /><ellipse cx="50" cy="44" rx="10" ry="6" fill="#17A2A2" transform="rotate(20 50 44)" />
      <ellipse cx="62" cy="20" rx="10" ry="6" fill="#2BA36B" transform="rotate(-20 62 20)" /></g>
  ),
  hand: (
    <g><circle cx="40" cy="40" r="22" fill="#6B4630" /><circle cx="40" cy="40" r="11" fill="#E0B33A" /></g>
  ),
};

export const GameIcon = ({ kind, size = 84 }) => (
  <svg viewBox="0 0 80 80" width={size} height={size} aria-hidden>{ICONS[kind]}</svg>
);

export const GameTarget = ({ kind, pos, testId, progress = 0, dim = false, pulse = true }) => (
  <div data-testid={testId}
    className={`pointer-events-none absolute flex items-center justify-center ${pulse ? "target-pulse" : ""}`}
    style={{ left: `${pos.x * 100}%`, top: `${pos.y * 100}%`, transform: "translate(-50%,-50%)", opacity: dim ? 0.5 : 1 }}>
    <span className="ring-wave absolute h-24 w-24 rounded-full border-4 border-white/80" />
    <span className="absolute h-24 w-24 rounded-full bg-white/35 backdrop-blur-sm" />
    {progress > 0 && (
      <svg className="absolute h-28 w-28 -rotate-90" viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="46" fill="none" stroke="#E0B33A" strokeWidth="7" strokeDasharray={`${progress * 289} 289`} strokeLinecap="round" />
      </svg>
    )}
    <div className="relative"><GameIcon kind={kind} /></div>
  </div>
);
